import React from "react";
import { Container, Box, useMediaQuery, useTheme, Link } from "@mui/material";
import PageSelector from "./PageSelector";
import DateSelector from "./DateSelector";
import FrequencySelector from "./FrequencySelector";
import ChartContainer from "./ChartContainer";
import { useDashboard } from "../context/DashboardProvider";
import Title from "./Title";
import Footer from "./Footer";
import AnalyzeData from "./AnalyzeData"; // Import the new analysis component

const DashboardLayout = () => {
  const { data } = useDashboard();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container
      maxWidth="lg"
      sx={{
        backgroundColor: theme.palette.background.default,
        minWidth: "60%",
        minHeight: "100vh",
        py: 4,
      }}
    >
      <Title text="AVA Interest on Wikipedia" />

      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Box
          sx={{
            width: isMobile ? "100%" : "25%",
            minWidth: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderRight: isMobile ? "none" : "1px solid rgba(255, 255, 255, 0.2)",
            pr: isMobile ? 0 : 2,
          }}
        >
          <Box>
            <PageSelector />
            <DateSelector />
            <FrequencySelector />
          </Box>
          {/* <Box sx={{ textAlign: "center", mt: 2 }}>
            <Link
              href="https://www.fincuva.com/"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              underline="none"
            >
              © fincuva
            </Link>
          </Box> */}
        </Box>

        <Box sx={{ flexGrow: 1, width: isMobile ? "100%" : "75%" }}>
          <ChartContainer data={data} />
          <AnalyzeData /> {/* New analysis component appears right under the chart */}
          <Footer />
        </Box>
      </Box>
    </Container>
  );
};

export default DashboardLayout;
